import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { changeLang, toggleModal, toggleSpinner } from 'actions/appAction';

import { UI_LANGUAGE } from 'constants/amplitude/AmplitudeParamName';

import { getLangCountryPrefix } from 'helpers/utils';

import amplitude from 'amplitude-js';
import promoColors from 'theme/promoColors';

import PromoModalComponent from './PromoModalComponent';
import { LightHeaderPanel } from '../common/fromAuth/LightHeaderPanel/LightHeaderPanel';
import { PromoText } from '../common/promo-text/PromoText';

const LangList = styled.ul`
    margin: 0 -24px;
`;
const LangLink = styled.a`
    display: flex;
    align-items: center;
    padding: 16px 24px;
    background: ${(props) => (props.isSelected ? promoColors.purple5 : null)};

    &:hover {
        background: ${promoColors.purple5};
    }

    &:focus-visible {
        outline: 1px dashed ${promoColors.baseColor};
    }
`;

const PromoLanguages = (props) => {
    const handleChangeLanguage = (e, lang) => {
        e.preventDefault();
        if (props.isRequest) {
            window.location.replace(`${getLangCountryPrefix(lang, props.country)}/request`);
            props.toggleSpinner(true);
        } else if (props.isLanding) {
            window.location.replace(getLangCountryPrefix(lang, props.country));
            props.toggleSpinner(true);
        } else {
            const regex = /\/([a-z]{2})-([a-z]{2})(\/+.*)/;
            const { pathname } = window.location;
            const result = pathname.match(regex) || [];
            let url;
            if (result.length > 0 && result[3].length > 0) {
                url = result[3];
            } else {
                url = pathname;
            }
            window.location.replace(`${getLangCountryPrefix(lang, props.country)}${url}`);
            props.toggleSpinner(true);
        }
        amplitude.getInstance().setUserProperties({ [UI_LANGUAGE]: lang });
        props.toggleModal(false);
    };

    const getDropList = (languages) => {
        return (
            <LangList>
                {languages.map((lang) => (
                    <PromoText key={lang.localeCode} tag="listItem" color="gray80">
                        <LangLink
                            id={`lang-${lang.localeCode}`}
                            href={getLangCountryPrefix(lang.localeCode, props.country)}
                            onClick={(e) => handleChangeLanguage(e, lang.localeCode)}
                            isSelected={props.lang === lang.localeCode}
                        >
                            {lang.name}
                        </LangLink>
                    </PromoText>
                ))}
            </LangList>
        );
    };

    return (
        <PromoModalComponent isIconClose>
            <LightHeaderPanel title={props.title} />
            {getDropList(props.languages)}
        </PromoModalComponent>
    );
};

PromoLanguages.propTypes = {
    lang: PropTypes.string.isRequired,
    languages: PropTypes.arrayOf(
        PropTypes.shape({
            locale: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        }),
    ).isRequired,
};

const mapStateToProps = () => {
    return {};
};

export default connect(mapStateToProps, { changeLang, toggleModal, toggleSpinner })(PromoLanguages);
